import React from "react";
import styles from "./Home.module.css";
import { Button } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import axios from "axios";
const Home = () => {
  
  const history = useHistory();
  function setDeviceId(deviceId) {
    // Handle the device ID received from Flutter
    console.log('Device ID:', deviceId);
  
    // Send the device ID to your server or perform any other actions
    // e.g., subscribe the device to receive push notifications
  }

 
  return (
    // <div className={styles.pageContainer}>
      <section className={styles.hero}>
        <h1>Sadhana Ayurvedics Pvt. Ltd </h1>
        <div className={styles.wrap}>
          <button  onClick={() => history.push("/login")} className={styles.login}> Get started</button>
          {/* <button  onClick={handleSendNotification} className={styles.login}>Push Notification</button> */}
        </div>
      </section>
    // </div>
  );
};

export default Home;
